import { GameRulesServiceEvent, IServices } from "@netent/origin";
import { IPlayUIState, View } from "@netent/playui";
import { ListenerCreator } from "../../types";

const contentChanged = () => (content: string): IPlayUIState => ({
  gameRules: {
    content
  }
});

const closed = () => (): IPlayUIState => ({
  view: View.DEFAULT
});

const opened = () => (): IPlayUIState => ({
  view: View.GAME_RULES
});

const enabled = (services: IServices) => (): IPlayUIState => ({
  gameRules: {
    content: services.gameRules.getContent()
  }
});

const disabled = () => (): IPlayUIState => ({
  gameRules: null
});

export const listeners = new Map<GameRulesServiceEvent, ListenerCreator>([
  ["contentChanged", contentChanged],
  ["closed", closed],
  ["opened", opened],
  ["enabled", enabled],
  ["disabled", disabled]
]);
